var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52232 0.133539C1.44889 1.69046 0.297071 3.50236 0.0665972 5.57021C-0.292192 8.78868 2.16949 10.364 3.41686 8.94869C4.66422 7.5331 3.91663 5.73665 3.01346 5.24537C2.11029 4.7544 1.55793 4.92535 1.6543 4.26891C1.75068 3.61279 3.03549 1.79316 4.16445 0.945804C4.20446 0.906029 4.22998 0.849908 4.23582 0.788887C4.24165 0.727866 4.22735 0.666542 4.19584 0.617421L3.91663 0.192777C3.79547 0.00862481 3.67927 0.0157075 3.52232 0.133217V0.133539ZM8.98154 0.133539C6.9081 1.69046 5.75601 3.50268 5.52581 5.57021C5.16702 8.78868 7.62871 10.364 8.87608 8.94869C10.1234 7.5331 9.37585 5.73665 8.4724 5.24537C7.56923 4.7544 7.01687 4.92535 7.11324 4.26891C7.20962 3.61279 8.49471 1.79316 9.62367 0.945804C9.66363 0.905984 9.6891 0.849841 9.69489 0.788822C9.70067 0.727803 9.68633 0.666503 9.65478 0.617421L9.37557 0.192777C9.25442 0.00862481 9.13822 0.0157075 8.98154 0.133217V0.133539Z",
    fill: "#FAD97F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote1);
export default __webpack_public_path__ + "static/media/Quote1.daad3a8198e09db929b2a72e70eb26a1.svg";
export { ForwardRef as ReactComponent };